import type { FC } from "react";
import { useChartHeight } from "recharts";

export const SparklineGradient: FC<{
  id: string;
  color: string;
}> = ({ id, color }) => {
  const height = useChartHeight();

  if (height == null) {
    return null;
  }

  return (
    <defs>
      <linearGradient
        id={id}
        x1="0"
        x2="0"
        y1="0"
        y2={height}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor={color} stopOpacity={0.4} />
        <stop offset="0.8" stopColor={color} stopOpacity={0} />
      </linearGradient>
    </defs>
  );
};
